import { EventInput } from '@fullcalendar/core';
import FullCalendar from '@fullcalendar/react';
import { useEffect } from 'react';

export const useManualEventsSync = (
  calendarRef: React.RefObject<FullCalendar | null>,
  events: EventInput[],
) => {
  useEffect(() => {
    if (!calendarRef.current) {
      return;
    }
    const calendarApi = calendarRef.current.getApi();

    const update = () => {
      // Remove all events that are NOT tasks (assuming tasks have extendedProps.taskId)
      // This syncs "Goals" and "External" events
      const currentEvents = calendarApi.getEvents();
      currentEvents.forEach((event: any) => {
        if (!event.extendedProps?.taskId) {
          event.remove();
        }
      });

      // Add new events
      events.forEach((event) => {
        calendarApi.addEvent(event);
      });
    };

    const timeoutId = setTimeout(() => {
      if ((calendarApi as any).batchRendering) {
        (calendarApi as any).batchRendering(update);
        return;
      }

      update();
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [events, calendarRef]); // When the source list changes, we do a full replace of non-task events
};
